export default "__VITE_ASSET__BlVpq7Np__"